import React, { useState, useEffect } from 'react';
import { Plus, List, Edit2, Trash2 } from 'lucide-react';
import { getAllDescription, saveExpenseDescription, deleteExpenseDescriptionById, getAllExpenseCategory, getAllExpenseSubCategory } from '../../../targetactioncreator';
import moment from 'moment';

function TAB3({ dateFilter }) {
  const [showAddForm, setShowAddForm] = useState(false);
  const [showList, setShowList] = useState(true);
  const [editingItem, setEditingItem] = useState(null);
  const [descriptions, setDescriptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    category: '',
    subCategory: '',
    expenseCycle: '',
    isActive: false,
    description: ''
  });
  const [errors, setErrors] = useState({});

  // Load data from API on component mount and when date filter changes
  useEffect(() => {
    loadCategories();
    loadDescriptions();
  }, [dateFilter]);

  useEffect(() => {
    if (formData.category) {
      loadSubcategories(formData.category);
    }
  }, [formData.category]);

  const loadCategories = () => {
    getAllExpenseCategory('notRequired', '', '', (response) => {
      if (response && response.data) {
        setCategories(response.data);
      }
    }, (error) => {
      console.error('Error loading categories:', error);
    });
  };

  const loadSubcategories = (categoryId, preSelectId = null) => {
    getAllExpenseSubCategory('notRequired', '', '', categoryId, (response) => {
      if (response && response.data) {
        setSubcategories(response.data);
        if (preSelectId) {
          setFormData(prev => ({ ...prev, subCategory: preSelectId }));
        }
      }
    }, (error) => {
      console.error('Error loading subcategories:', error);
    });
  };

  const loadDescriptions = () => {
    setLoading(true);
    
    if (dateFilter && dateFilter.active) {
      // Convert dates from YYYY-MM-DD to DD-MM-YYYY format for API
      const fromDate = dateFilter.fromDate ? moment(dateFilter.fromDate).format('DD-MM-YYYY') : '';
      const toDate = dateFilter.toDate ? moment(dateFilter.toDate).format('DD-MM-YYYY') : '';
      
      console.log('Loading descriptions with dates:', { fromDate, toDate });
      
      // Load descriptions with date filter
      getAllDescription('dateRequired', fromDate, toDate, (response) => {
        if (response && response.data) {
          setDescriptions(response.data);
          console.log('Descriptions loaded with filter:', response.data);
        }
        setLoading(false);
      }, (error) => {
        console.error('Error loading descriptions:', error);
        setLoading(false);
      });
    } else {
      // Load descriptions without date filter
      getAllDescription('notRequired', '', '', (response) => {
        if (response && response.data) {
          setDescriptions(response.data);
          console.log('Descriptions loaded without filter:', response.data);
        }
        setLoading(false);
      }, (error) => {
        console.error('Error loading descriptions:', error);
        setLoading(false);
      });
    }
  };

  const handleAddClick = () => {
    setShowAddForm(true);
    setShowList(false);
    setEditingItem(null);
    setFormData({ category: '', subCategory: '', expenseCycle: '', isActive: false, description: '' });
    setErrors({});
  };

  const handleListClick = () => {
    setShowList(true);
    setShowAddForm(false);
    setEditingItem(null);
  };

  const handleCloseForm = () => {
    setShowAddForm(false);
    setEditingItem(null);
    setFormData({ category: '', subCategory: '', expenseCycle: '', isActive: false, description: '' });
    setErrors({});
  };

  const handleEditClick = (description) => {
    setEditingItem(description);
    setFormData({
      category: description.categoryId,
      subCategory: '',
      expenseCycle: description.expenseCycle,
      isActive: description.active,
      description: description.expenseDescription
    });
    loadSubcategories(description.categoryId, description.subCategoryId);
    setShowAddForm(true);
    setShowList(false);
    setErrors({});
  };

  const handleDeleteClick = (descriptionId) => {
    if (window.confirm('Are you sure you want to delete this expense detail?\n\nThis action cannot be undone.')) {
      deleteExpenseDescriptionById(descriptionId, (response) => {
        console.log('Expense detail deleted successfully:', response);
        loadDescriptions(); // Reload the list
      }, (error) => {
        console.error('Error deleting expense detail:', error);
        alert('Error deleting expense detail. Please try again.');
      });
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const handleCheckboxChange = (field, checked) => {
    setFormData(prev => ({ ...prev, [field]: checked }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.category.trim()) {
      newErrors.category = 'Category is mandatory';
    }
    if (!formData.subCategory.trim()) {
      newErrors.subCategory = 'Sub-Category is mandatory';
    }
    if (!formData.expenseCycle.trim()) {
      newErrors.expenseCycle = 'Expense Cycle is mandatory';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveData = () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const descriptionData = {
      categoryId: formData.category,
      subCategoryId: formData.subCategory,
      expenseCycle: formData.expenseCycle,
      isActive: formData.isActive,
      description: formData.description
    };

    if (editingItem) {
      // Update existing description (you may need to add update API)
      descriptionData.descriptionId = editingItem.id;
    }

    saveExpenseDescription(descriptionData, (response) => {
      console.log('Expense detail saved successfully:', response);
      loadDescriptions(); // Reload the list
      handleCloseForm();
    }, (error) => {
      console.error('Error saving expense detail:', error);
      alert('Error saving expense detail. Please try again.');
    });
  };

  return (
    <div style={{ textAlign: "center" }}>
      {/* Left Side Tabs */}
      <div style={{ 
        display: "flex", 
        flexDirection: "row", 
        alignItems: "center", 
        marginBottom: "32px",
        gap: "8px",
        flexWrap: "wrap"
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          padding: "4px 8px",
          background: "#f8fafc",
          borderRadius: "4px",
          border: "1px solid #e2e8f0",
          cursor: "pointer",
          transition: "all 0.2s ease"
        }} onClick={handleAddClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-plus-icon lucide-square-plus" style={{ color: "#015c57" }}>
            <rect width="18" height="18" x="3" y="3" rx="2"/>
            <path d="M8 12h8"/>
            <path d="M12 8v8"/>
          </svg>
          <span style={{ 
            fontSize: "11px", 
            fontWeight: "600", 
            color: "#015c57" 
          }}>
            ADD 
          </span>
        </div>

        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          padding: "4px 8px",
          background: "#f8fafc",
          borderRadius: "4px",
          border: "1px solid #e2e8f0",
          cursor: "pointer",
          transition: "all 0.2s ease"
        }} onClick={handleListClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-check-icon lucide-list-check" style={{ color: "#015c57" }}>
            <path d="M16 5H3"/>
            <path d="M16 12H3"/>
            <path d="M11 19H3"/>
            <path d="m15 18 2 2 4-4"/>
          </svg>
          <span style={{ 
            fontSize: "11px", 
            fontWeight: "600", 
            color: "#015c57" 
          }}>
            LIST 
          </span>
        </div>
      </div>

      {/* Add/Edit Description Form - Integrated Non-Modal */}
      {showAddForm && (
        <div style={{
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          padding: "24px",
          marginBottom: "32px",
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto 32px auto"
        }}>
          {/* Form Header */}
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            paddingBottom: "16px",
            borderBottom: "1px solid #e2e8f0"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "12px"
            }}>
              <div style={{
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#015c57",
                color: "#ffffff"
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="18" height="18" x="3" y="3" rx="2"/>
                  <path d="M8 12h8"/>
                  <path d="M12 8v8"/>
                </svg>
              </div>
              <div style={{ textAlign: "left" }}>
                <h3 style={{
                  margin: "0",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#1e293b"
                }}>
                  {editingItem ? 'Edit Expense Details' : 'Add Expense Details'}
                </h3>
                <div style={{
                  fontSize: "12px",
                  color: "#64748b",
                  marginTop: "2px"
                }}>
                  {editingItem ? 'Update expense details' : 'Enter expense details to create new expense record'}
                </div>
              </div>
            </div>
            <button
              onClick={handleCloseForm}
              style={{
                backgroundColor: "transparent",
                border: "1px solid #e2e8f0",
                fontSize: "16px",
                cursor: "pointer",
                color: "#64748b",
                padding: "0",
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "6px",
                transition: "all 0.2s ease"
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#f1f5f9";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "transparent";
              }}
            >
              ×
            </button>
          </div>

          {/* Form Fields */}
          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginBottom: "20px"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "20px"
            }}>
              <label style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                minWidth: "180px",
                textAlign: "left"
              }}>
                Category <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <div style={{ flex: 1 }}>
                <select
                  value={formData.category}
                  onChange={(e) => handleInputChange('category', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: errors.category ? "1px solid #ef4444" : "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "#ffffff",
                    color: "#1f2937",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#015c57";
                    e.target.style.boxShadow = "0 0 0 2px rgba(1,92,87,0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = errors.category ? "#ef4444" : "#d1d5db";
                    e.target.style.boxShadow = "none";
                  }}
                >
                  <option value="">Select category</option>
                  {categories.map((cat) => (
                    <option key={cat.categoryId} value={cat.categoryId}>
                      {cat.categoryName}
                    </option>
                  ))}
                </select>
                {errors.category && (
                  <div style={{
                    color: "#ef4444",
                    fontSize: "12px",
                    marginTop: "4px"
                  }}>
                    {errors.category}
                  </div>
                )}
              </div>
            </div>

            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "20px"
            }}>
              <label style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                minWidth: "180px",
                textAlign: "left"
              }}>
                Sub-Category <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <div style={{ flex: 1 }}>
                <select
                  value={formData.subCategory}
                  onChange={(e) => handleInputChange('subCategory', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: errors.subCategory ? "1px solid #ef4444" : "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "#ffffff",
                    color: "#1f2937",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#015c57";
                    e.target.style.boxShadow = "0 0 0 2px rgba(1,92,87,0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = errors.subCategory ? "#ef4444" : "#d1d5db";
                    e.target.style.boxShadow = "none";
                  }}
                >
                  <option value="">Select sub-category</option>
                  {subcategories.map((sub) => (
                    <option key={sub.id} value={sub.id}>
                      {sub.subCategoryName}
                    </option>
                  ))}
                </select>
                {errors.subCategory && (
                  <div style={{
                    color: "#ef4444",
                    fontSize: "12px",
                    marginTop: "4px"
                  }}>
                    {errors.subCategory}
                  </div>
                )}
              </div>
            </div>

            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "20px"
            }}>
              <label style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                minWidth: "180px",
                textAlign: "left"
              }}>
                Expense Cycle <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <div style={{ flex: 1 }}>
                <select
                  value={formData.expenseCycle}
                  onChange={(e) => handleInputChange('expenseCycle', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: errors.expenseCycle ? "1px solid #ef4444" : "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "#ffffff",
                    color: "#1f2937",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#015c57";
                    e.target.style.boxShadow = "0 0 0 2px rgba(1,92,87,0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = errors.expenseCycle ? "#ef4444" : "#d1d5db";
                    e.target.style.boxShadow = "none";
                  }}
                >
                  <option value="">Select expense cycle</option>
                  <option value="Daily">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Quarterly">Quarterly</option>
                  <option value="Yearly">Yearly</option>
                </select>
                {errors.expenseCycle && (
                  <div style={{
                    color: "#ef4444",
                    fontSize: "12px",
                    marginTop: "4px"
                  }}>
                    {errors.expenseCycle}
                  </div>
                )}
              </div>
            </div>

            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "20px"
            }}>
              <label style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                minWidth: "180px",
                textAlign: "left"
              }}>
                Is Active
              </label>
              <div style={{ flex: 1 }}>
                <input
                  type="checkbox"
                  checked={formData.isActive}
                  onChange={(e) => handleCheckboxChange('isActive', e.target.checked)}
                  style={{
                    width: "20px",
                    height: "20px",
                    cursor: "pointer",
                    accentColor: "#015c57"
                  }}
                />
                <span style={{
                  marginLeft: "8px",
                  fontSize: "14px",
                  color: "#64748b"
                }}>
                  {formData.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>

            <div style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "20px"
            }}>
              <label style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                minWidth: "180px",
                textAlign: "left",
                paddingTop: "10px"
              }}>
                Description
              </label>
              <div style={{ flex: 1 }}>
                <textarea
                  value={formData.description}
                  onChange={(e) => handleInputChange('description', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "#ffffff",
                    color: "#1f2937",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box",
                    minHeight: "80px",
                    resize: "vertical"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#015c57";
                    e.target.style.boxShadow = "0 0 0 2px rgba(1,92,87,0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#d1d5db";
                    e.target.style.boxShadow = "none";
                  }}
                  placeholder="Enter description"
                />
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
            paddingTop: "16px",
            borderTop: "1px solid #e2e8f0"
          }}>
            <button
              onClick={handleCloseForm}
              style={{
                padding: "8px 20px",
                background: "#ffffff",
                color: "#64748b",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
              onMouseOver={(e) => {
                e.target.style.background = "#f8fafc";
                e.target.style.borderColor = "#d1d5db";
              }}
              onMouseOut={(e) => {
                e.target.style.background = "#ffffff";
                e.target.style.borderColor = "#e2e8f0";
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSaveData}
              style={{
                padding: "8px 20px",
                background: "#015c57",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
              onMouseOver={(e) => {
                e.target.style.background = "#0a7d75";
              }}
              onMouseOut={(e) => {
                e.target.style.background = "#015c57";
              }}
            >
              {editingItem ? 'Update Data' : 'Save Data'}
            </button>
          </div>
        </div>
      )}

      {/* List Descriptions */}
      {showList && (
        <div style={{
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          padding: "24px",
          marginBottom: "32px",
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto 32px auto"
        }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            paddingBottom: "16px",
            borderBottom: "1px solid #e2e8f0"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "12px"
            }}>
              <div style={{
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#015c57",
                color: "#ffffff"
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 5H3"/>
                  <path d="M16 12H3"/>
                  <path d="M11 19H3"/>
                  <path d="m15 18 2 2 4-4"/>
                </svg>
              </div>
              <div style={{ textAlign: "left" }}>
                <h3 style={{
                  margin: "0",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#1e293b"
                }}>
                  Expense Details
                </h3>
                <div style={{
                  fontSize: "12px",
                  color: "#64748b",
                  marginTop: "2px"
                }}>
                  Manage your expense details
                </div>
              </div>
            </div>
            <div style={{
              fontSize: "14px",
              color: "#64748b",
              fontWeight: "500"
            }}>
              {descriptions.length} descriptions
            </div>
          </div>

          {descriptions.length === 0 ? (
            <div style={{
              textAlign: "center",
              padding: "40px",
              color: "#64748b"
            }}>
              <div style={{
                fontSize: "48px",
                color: "#e2e8f0",
                marginBottom: "16px"
              }}>
                📋
              </div>
              <div style={{
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "8px"
              }}>
                No descriptions found
              </div>
              <div style={{
                fontSize: "14px"
              }}>
                Click ADD to create your first expense description
              </div>
            </div>
          ) : (
            <div style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              overflow: "hidden"
            }}>
              {/* Table Header */}
              <div style={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr 120px",
                backgroundColor: "#f8fafc",
                borderBottom: "1px solid #e2e8f0"
              }}>
                <div style={{
                  padding: "12px 16px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  borderRight: "1px solid #e2e8f0"
                }}>
                  Expense Description
                </div>
                <div style={{
                  padding: "12px 16px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  borderRight: "1px solid #e2e8f0"
                }}>
                  Expense Cycle
                </div>
                <div style={{
                  padding: "12px 16px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  textAlign: "center"
                }}>
                  Actions
                </div>
              </div>

              {/* Table Rows */}
              {descriptions.map((description, index) => (
                <div key={description.id} style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr 120px",
                  borderBottom: index < descriptions.length - 1 ? "1px solid #e2e8f0" : "none",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease"
                }}>
                  <div style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#1e293b",
                    borderRight: "1px solid #e2e8f0",
                    fontWeight: "500"
                  }}>
                    {description.expenseDescription || 'N/A'}
                  </div>
                  <div style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#64748b",
                    borderRight: "1px solid #e2e8f0"
                  }}>
                    {description.expenseCycle || 'N/A'}
                  </div>
                  <div style={{
                    padding: "12px 16px",
                    display: "flex",
                    gap: "6px",
                    justifyContent: "center",
                    alignItems: "center"
                  }}>
                    <div
                      onClick={() => handleEditClick(description)}
                      style={{
                        padding: "4px 8px",
                        background: "#015c57",
                        color: "#ffffff",
                        border: "none",
                        borderRadius: "4px",
                        fontSize: "11px",
                        fontWeight: "500",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px"
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = "#0a7d75";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = "#015c57";
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen-icon lucide-square-pen" style={{ width: "14px", height: "14px" }}>
                        <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/>
                      </svg>
                    </div>
                    <div
                      onClick={() => handleDeleteClick(description.id)}
                      style={{
                        padding: "4px 8px",
                        background: "#6b7280",
                        color: "#ffffff",
                        border: "none",
                        borderRadius: "4px",
                        fontSize: "11px",
                        fontWeight: "500",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px"
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = "#374151";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = "#6b7280";
                      }}
                    >
                      <Trash2 size={14} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

          </div>
  );
}

export default TAB3;